import { Enum } from "../commons/common";
import { SortDirection } from "../order/order";
interface Market {
    id: string;
    symbol: string;
    name: string;
}

interface BankAccount {
    id: number | null;
    cardNumber: string | null;
    iBan: string | null;
    bankName: string | null;
}

export interface Transaction {
    trackingCode: string;
    market: Market;
    amount: number;
    type: Enum;
    state: Enum;
    createdAt: string;
    network: {
        name: string;
        fee: number;
        network: string;
    };
    paymentIdentifier: string;
    voucher: {
        batchNumber: string;
        voucherCode: string;
        voucherActivationCode: string;
    };
    txId: string;
    bankAccount: BankAccount;
    commission: number;
    wallet: {
        walletAddress: string;
        memo: string;
    };
    balanceAfterTransaction: number;
    onPrice: number;
    digitalReceipt: string;
    platform: Enum;
    phoneNumber: string;
    gateWayName: string;
    description: string;
    payoutAmount: number;
    depositIrtType: Enum;
    createdBy: string;
    userId?: string;
    isAutoGenerated: boolean;
    id: string;
}

export interface TransactionCount {
    pageSize: number;
    pageIndex: number;
    totalPages: number;
    totalCount: number;
    hasPreviousPage: boolean;
    hasNextPage: boolean;
}

export interface TransactionFilterValues {
    startDate?: string;
    endDate?: string;
    sort?: SortDirection;
    market?: string;
    trackingCode?: string;
    fullName?: string;
    phoneNumber?: string;
    bankAccount?: string;
    txId?: string;
    paymentIdentifier?: string;
    creatorId?: string;
    walletAddress?: string;
    voucherCode?: string;
    voucherActivationCode?: string;
    minAmount?: string;
    maxAmount?: string;
    source?: Enum;
    marketType?: Enum;
    type?: Enum;
    state?: Enum;
    platform: Enum;
    depositCurrencyType: Enum;
}

export enum TransactionType {
    Deposit = 1,
    Withdrawal,
}

export enum TransactionState {
    Waiting = 1,
    Succeed,
    Rejected,
    WaitingForOtp,
    WaitingForAdmin,
}

export enum TransactionMarketType {
    Crypto = 1,
    Fiat = 3,
    Currency = 4,
    UUSD = 5,
}

/** Mirrors IrtWithdrawalAdminAction on the backend. */
export enum IrtWithdrawalAdminAction {
    Approve = 1,
    ApproveAndPayout,
    Reject,
}

// type alias (نه interface) تا بتوان مستقیم به عنوان Record<string, number> به منو پاس داد.
export type WaitingItemCount = {
    irtTransactionsWaitingForApprove: number;
    irtWithdrawalsWaitingForApprove: number;
    buyWaitingForAcceptReceipt: number;
    sellWaitingForAcceptReceipt: number;
    tradeWaitingForAcceptReceipt: number;
    authMediasWaitingForApprove: number;
};

export interface TransactionDetails {
    id: string;
    trackingCode: string;
    orderTransactionTrackingCode: string | null;
    depositTrackingCode: string | null;
    withdrawalTrackingCode: string | null;
    market: Market;
    description: string | null;
    amount: number;
    type: Enum;
    createdBy: string;
    userId?: string;
    platform: Enum;
    state: Enum;
    createdAt: string; // ISO 8601 format date
    payoutAmount: number;
    level: Enum;
    hasApprovedSelfie?: boolean;
    bankAccount: BankAccount;
    paymentIdentifier: string | null;
    depositIrtType: Enum;
    network: {
        name: string;
        fee: number;
        network: string;
    };
    receptMedia: string | null;
    txId: string | null;
    digitalReceipt: string | null;
    onPrice: number;
    wallet: {
        walletAddress: string;
        memo: string;
    };
    ip: string;
    voucherCode: string | null;
    voucherActivationCode: string | null;
    commission: number;
    lastModifiedDate: string; // ISO 8601 format date
    lastModifiedBy: string;
    balanceAfterTransaction: number | null;
}
